import { Component } from '@angular/core';
import { JobseekerSkillsEditFormComponent as LibJobseekerSkillsEditFormComponent } from '@hrra/common-components';

//redesigned skills edit form of the public portal; the search, add, remove and reorder logic
//comes from the lib form, which customer-app still renders with the old design
@Component({
    selector: 'app-jobseeker-skills-edit-form',
    templateUrl: './jobseeker-skills-edit-form.component.html',
    styleUrls: ['./jobseeker-skills-edit-form.component.scss'],
    standalone: false
})
export class JobseekerSkillsEditFormComponent extends LibJobseekerSkillsEditFormComponent {}
